import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

import { map, Observable } from 'rxjs';
import { Banner } from './shared/models/app.model';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { GuestAppearanceService } from './services/guest-appearance.service';
import { SettingsService } from './services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public globalBanners: Observable<Banner[]>;

  constructor(
    public afAuth: AngularFireAuth,
    firestore: AngularFirestore,
    translate: TranslocoService,
    settings: SettingsService,
    guestAppearance: GuestAppearanceService,
    private router: Router,
    private dialog: MatDialog
  ) {
    translate.setDefaultLang('en');

    // MIC-312: hook the guest appearance WS stream early so the brand colour
    // pushed at guest connect time paints the chrome. No-op for non-guests
    // (the guest websocket only carries guest events).
    guestAppearance.start();

    this.globalBanners = firestore
      .collection<Banner>('global-banners', (ref) =>
        ref.where('enabled', '==', true)
      )
      .valueChanges({ idField: 'documentID' })
      .pipe(
        map((banners) =>
          banners.filter((banner) => {
            // Don't show banners on av-view route
            if (this.router.url.includes('av-view')) {
              return false;
            }

            if (banner?.persistent) {
              return true;
            }
            return !settings.localSettings.closedBanners.includes(
              banner.documentID
            );
          })
        )
      );

    // Watch the page translation status, because this messes up showing live
    // transcription updates.
    // https://stackoverflow.com/a/58891538/11322000
    const observer = new MutationObserver(() => {
      if (!document.documentElement.className.includes('translated')) {
        return;
      }

      // show dialog telling the user that browser translations break
      // the app
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'confirm_dialog.browser_translation.title',
          message: 'confirm_dialog.browser_translation.message',
          icon: 'fa-exclamation-triangle',
          confirmButton: {
            text: 'confirm_dialog.browser_translation.confirm',
          },
        },
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    });
  }
}
